import React from "react";
import { Navigate } from "react-router-dom";

function AIQuery() {
  return <Navigate to="/tables?panel=ai" replace />;
}

export default AIQuery;
